/** @format */

export const DEFAULT_TEST_ID = 'product-wrapped-link';
